export default __webpack_public_path__ + "static/flag-lu-817ce3721e672fe7aea22d969de89240.svg";